const state = {
  metadataObserverOriginal : undefined
}

const getters = {
  metadataObserverOriginal: state => {
    return state.metadataObserverOriginal
  },
}

const actions = {
  setOriginalObserver({ commit }, metadataObserver) {
    return commit('SET_ORIGINAL_OBSERVER', metadataObserver);
  },
}

const mutations = {
  SET_ORIGINAL_OBSERVER(state, metadataObserver) {
    state.metadataObserverOriginal = metadataObserver
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};